import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import Condition from './Condition'
import Controls from './Controls'

import style from './style.sass'

@inject('store') @observer
class Main extends Component {
  render() {
    const {conditions} = this.props.store.stockFilter.single.data
    return(
      <div styleName='wrapper'>
        <h3>Filter conditions:</h3>
        {conditions.map((condition, index) =>
          <Condition key={index} id={index} condition={condition}/>
        )}
        <Controls/>
      </div>
    )
  }
}

export default Main
